import { useEffect, useState } from "react";
import Button from "../common/Button";
import { getAiWriting, saveAiWriting } from "../../api/email";

// What Claude knows about Birdie Bus when it drafts replies and newsletters.
// Package prices come from Services; this is everything else.

export default function AiWritingPanel({ onNotice, onError }) {
  const [data, setData] = useState(null);
  const [facts, setFacts] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getAiWriting()
      .then((d) => {
        setData(d);
        setFacts(d.facts);
      })
      .catch((e) => onError(e.message || "Couldn't load Claude's settings."));
  }, [onError]);

  if (!data) return null;

  async function save(text) {
    setBusy(true);
    onError("");
    try {
      const r = await saveAiWriting(text);
      setData((d) => ({ ...d, facts: r.facts }));
      setFacts(r.facts);
      onNotice("Saved. Claude uses this from the next draft.");
    } catch (e) {
      onError(e.message || "Couldn't save.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-3 text-sm text-birdie-charcoal/80">
      {data.enabled ? (
        <p>
          <span className="text-birdie-green font-semibold">✓ On.</span> Claude drafts your first reply to new leads and
          the monthly newsletter, and rewrites any draft when you ask. You read and approve everything it writes.
        </p>
      ) : (
        <p className="text-amber-800">
          Claude isn't set up on the server yet, so replies and newsletters use the standard wording. It uses the same
          OpenRouter key as receipt scanning (<code>OPENROUTER_API_KEY</code>).
        </p>
      )}
      <label className="block">
        <span className="block text-xs font-semibold text-birdie-charcoal/70 mb-1">What Claude should know about Birdie Bus</span>
        <textarea
          value={facts}
          onChange={(e) => setFacts(e.target.value)}
          rows={10}
          maxLength={6000}
          className="w-full rounded-xl border border-birdie-green/20 bg-white px-3 py-2 text-xs leading-relaxed text-birdie-charcoal"
        />
        <span className="block text-[11px] text-birdie-charcoal/45 mt-1">
          Claude only states what's here and your package prices, so keep it true. Started from your website's FAQ.
        </span>
      </label>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={() => save(facts)} disabled={busy || facts === data.facts}>
          {busy ? "Saving…" : "Save"}
        </Button>
        {facts !== data.default_facts && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => window.confirm("Go back to the facts from your website?") && save("")}
            disabled={busy}
          >
            Reset to website facts
          </Button>
        )}
      </div>
    </div>
  );
}
